import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
export const promotionalApi = async () => {
  const { data = {} } = await axiosInstanceClient.get(API.promotional_api);
  return data;
};
